import React from "react";
import InputNumber from "../InputText/InputNumber";
import { InputMask } from "@react-input/mask";
import InputCep from "../InputText/InputCep";

interface props {
  idCnpj?:any;
  customerData: any;
  setCustomerData: any;
  setIsInvalid?: any;
  isInvalid?: {
    cep?: boolean;
    endereco?: boolean;
    bairro?: boolean;
    cidade?: boolean;
    estado?: boolean;
  };
}

const CustomerAddress: React.FC<props> = ({ idCnpj, customerData, setCustomerData, isInvalid, setIsInvalid }) => {

  const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { id, value } = event.target;
    setCustomerData((prevForm: any) => ({
      ...prevForm,
      [id]: value,
    }));

    setIsInvalid?.((prevForm: any) => ({
      ...prevForm,
      [id]: false,
    }));
  };

  const handleBlur = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { id, value } = e.target

    if (value.length == 0) {
      setIsInvalid?.((prevForm: any) => ({
        ...prevForm,
        [id]: true,
      }));
    }
  }

  return (
    <div className="row">
      <InputCep
        idCnpj={idCnpj}
        setCustomerData={setCustomerData}
        value={customerData?.cep}
        isInvalid={isInvalid}
        setIsInvalid={setIsInvalid}
        customerData={customerData}
      />
      <div className="col-md-6">
        <label>Endereço</label>
        <input
          id="endereco"
          className={`form-control ${isInvalid?.endereco ? 'is-invalid' : ''}`}
          type="text"
          value={customerData?.endereco}
          disabled={idCnpj ? true : false}
          placeholder="Endereço"
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <p className="invalid-feedback">Insira um Endereço</p>
      </div>
      <InputNumber
        id="numero"
        idCnpj={idCnpj}
        label="Número"
        value={customerData?.numero}
        setCustomerData={setCustomerData}
        isInvalid={isInvalid}
        setIsInvalid={setIsInvalid}
      />
      <div className="col-md-3">
        <label>Complemento</label>
        <input
          id="complemento"
          className="form-control"
          type="text"
          value={customerData?.complemento}
          disabled={idCnpj ? true : false}
          placeholder="Complemento"
          onChange={handleChange}
        />
      </div>
      <div className="col-md-3">
        <label>Bairro</label>
        <input
          id="bairro"
          className={`form-control ${isInvalid?.bairro ? 'is-invalid' : ''}`}
          type="text"
          value={customerData?.bairro}
          disabled={idCnpj ? true : false}
          placeholder="Bairro"
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <p className="invalid-feedback">Insira um Bairro</p>
      </div>
      <div className="col-md-4">
        <label>Cidade</label>
        <input
          id="cidade"
          className={`form-control ${isInvalid?.cidade ? 'is-invalid' : ''}`}
          disabled={idCnpj ? true : false}
          type="text"
          value={customerData?.cidade}
          placeholder="Cidade"
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <p className="invalid-feedback">Insira uma Cidade</p>
      </div>
      <div className="col-md-2">
        <label>Estado</label>
        <InputMask
          id="estado"
          className={`form-control ${isInvalid?.estado ? 'is-invalid' : ''}`}
          type="text"
          value={customerData?.estado.toUpperCase()}
          disabled={idCnpj ? true : false}
          placeholder="Estado"
          mask="__"
          replacement={{ _: /\D/ }}
          onChange={handleChange}
          onBlur={handleBlur}
        />
        <p className="invalid-feedback">Insira um Estado</p>
      </div>
    </div>
  )
}

export default CustomerAddress